module.exports = __webpack_public_path__ + "static/media/success-icon.656b8ab7.svg";